import { DotNetFormulaResultModel } from 'src/domain/dynamic-form/models';
import { FormulaTypeBaseHandler } from './formula-type-base.handler';

export class StringFormulaTypeHandler extends FormulaTypeBaseHandler {
	public handle(formula: DotNetFormulaResultModel, decimals: number | null): string | number {
		if (decimals) {
			// todo: ask if we should handle decimals places for string formulas
		}

		if (formula.stringResult === null || formula.stringResult === undefined) {
			if (this.next) {
				return this.next.handle(formula, decimals);
			}

			return '';
		}

		return formula.stringResult;
	}
}
